import { createApp, h } from 'vue'
import { router } from '@/router/index'
import { store } from '@/store/index'
import { useIconfont } from '@/components/iconfont'
import App from './App.vue'

// 动画库 全局指令 v-auto-animate
import { autoAnimatePlugin } from '@formkit/auto-animate/vue'

// 统计
import '@/utils/analyze/statistics'

import WujieVue from 'wujie-vue3'
import { JsonSchemaFormAntdV4 } from "@lljj/vue3-form-ant";
import { message, ConfigProvider, Form, Input, InputNumber } from 'ant-design-vue'
import zh_CN from 'ant-design-vue/es/locale/zh_CN'
import 'ant-design-vue/dist/reset.css'

import { themeConfig } from '@/hooks/themeUtil'

// windiCss
import 'virtual:windi.css'
import '@/assets/index.scss'

import dayjs from 'dayjs'
import 'dayjs/locale/zh-cn'

import 'maptalks/dist/maptalks.css';

dayjs.locale('zh-cn')
message.config({
  duration: 2,
  maxCount: 3,
  // top: '100px',
})

const antProvider = () => {
  return h(
    ConfigProvider,
    {
      componentSize: 'middle',
      locale: zh_CN,
      theme: themeConfig,
    },
    () => h(App)
  )
}

const plugins = [
  JsonSchemaFormAntdV4, 
  Form, Input, InputNumber
]

const app = createApp(antProvider).use(router).use(store).use(WujieVue).use(autoAnimatePlugin)

plugins.forEach(i => app.use(i))

useIconfont(app)

app.mount('#app')
